import React, { useEffect } from 'react';
import { useFetcher } from '@remix-run/react';
import cs from 'classnames';
import { useAtom, useAtomValue } from 'jotai';
import { $UserAgent, $Locale } from '@lemon8/web-app-shared/atom';
import { $UserFollowingTopic, $UserFollowTopicLoadmore } from 'shared/atoms';
import LoadMore from '~/components/load-more';
import { Loading } from '~/components/loading';
import HashtagCard from '~/components/simple-topic-card';
import { useTranslation } from 'react-i18next';
import { addRegionToSemanticUrl } from '~/utils/add-region-to-semantic-url';
import { fetchDataRoute } from '~/utils/fetch-data-route';
import { getImageUrl } from '~/utils/image';
import { Methods } from '../../constant';
import { $CurrentUserAsAvailable, $CurrentUserLinkName } from '@user/shared/atoms/current-user';

import './style.scss';
import { useRouteLoader } from '~/utils/use-route-loader';

const FollowTopic: React.FC = () => {
  const { t } = useTranslation();
  const { isMobile } = useAtomValue($UserAgent);
  const { region } = useAtomValue($Locale);
  const userLinkName = useAtomValue($CurrentUserLinkName);

  const { userId } = useAtomValue($CurrentUserAsAvailable);
  const data = useAtomValue($UserFollowingTopic(userLinkName));
  const { cursor = 0, data: topicList, has_more: hasMore } = data;

  const topicLoader = useRouteLoader(
    Methods.UserFollowingTopicLoadMore,
    {
      user_id: userId,
      count: 10,
      cursor,
    },
    {
      atomFamilies: {
        $UserFollowTopicLoadmore,
      },
    },
  );

  const loadData = async (): Promise<{
    data: any[];
  }> => {
    topicLoader.load();

    return { data: [] };
  };

  return (
    <div className={cs('user-topic', { isPC: !isMobile })}>
      <div className="user-topic-feed">
        <LoadMore
          loadData={loadData}
          isEnd={!hasMore}
          alwaysShowLoading={true}
          loadingText={<Loading variant="ball" fitParent={true} />}
          endText={topicList.length > 0 ? t('no_more_items') : t('no_content')}
          initList={topicList}
          render={() => (
            <div>
              {topicList.map((item: any, i: number) => {
                const { share_url } = item;
                const { canonicalUrl: topicCanonicalUrl } = addRegionToSemanticUrl(share_url, '', region);
                const { origin_uri } = item.background || {};
                let imgSrc = origin_uri ? getImageUrl(origin_uri) : '';
                if (imgSrc && !imgSrc.includes('http')) {
                  imgSrc = `https:${imgSrc}`;
                }
                return (
                  <HashtagCard
                    key={i}
                    aHref={`${topicCanonicalUrl}`}
                    name={item.name}
                    isDefault={true}
                    viewsCount={item.views_count}
                    size={'large'}
                    // onClick={(event: any) => {
                    //   event.preventDefault();
                    //   navigate(`${topicPath}?region=${region}`, {
                    //     state: {
                    //       page: PageType.topic,
                    //       data: item,
                    //     },
                    //   });
                    // }}
                  />
                );
              })}
            </div>
          )}
        />
      </div>
    </div>
  );
};

export default FollowTopic;
